import React, { Component } from "react";
import { Route, Switch, Redirect } from "react-router";
import { ConnectedRouter } from "connected-react-router";
import { connect } from "react-redux";
import _ from "lodash";
import CssBaseline from "@material-ui/core/CssBaseline";
import routes from "./routes";
import IconButton from "@material-ui/core/IconButton";
import Icon from "@material-ui/core/Icon";

import { dispatch } from "./store";

const styles = {
  section: {
    position: "fixed",
    bottom: "0",
    left: "0",
    background: "rgba(255,0,0,0.8)",
    width: "100%",
    padding: "11px",
    display: "flex",
    justifyContent: "space-between"
  },
  errorMessage: { color: "white" },
  iconButton: {
    paddingTop: "0px",
    paddingBottom: "0px",
    paddingRight: "0px",
    paddingLeft: "6px"
  },
  icon: {
    color: "white",
    fontSize: "19px",
    fontWeight: "bold"
  }
};

class App extends Component {
  render = () => {
    const { auth, closeError = () => {}, history } = this.props;
    const { isShowError, errorMessage } = auth;
    return (
      <div
        id="rootScreen"
        style={{
          position: "fixed",
          zIndex: 1,
          right: "0px",
          bottom: "0px",
          top: "0px",
          left: "0px",
          overflow: "auto"
        }}
      >
        <ConnectedRouter history={history}>
          <CssBaseline />
          <Switch>
            {routes.map((prop, key) => {
              if (prop.redirect) {
                return <Redirect from={prop.path} to={prop.pathTo} key={key} />;
              }
              return (
                <Route
                  key={key}
                  path={prop.path}
                  component={prop.component}
                  exact
                />
              );
            })}
          </Switch>
        </ConnectedRouter>
      </div>
    );
  };
}

const mapStateToProps = (state, ownProps) => {
  return {
    auth: state.auth || {}
  };
};

export default connect(mapStateToProps)(App);
